import { Component } from 'react';

import { Module, ModuleContent, ModuleHeader, type RequestError } from '../../shared';
import { Box, Flex } from '../../shared/components';
import { type Account, type Member, type OwnerPromotion } from '../model';

import { OwnerForm } from './OwnerForm';

import './members.scss';

type AccountOwnerPanelProps = Readonly<{
  account: Account;
  members: Member[];
  isUpdatingAccountOwner: boolean;
  accountOwnerUpdateError: RequestError | null;
  onChangeAccountOwner: (promotion: OwnerPromotion) => void;
}>;

export class AccountOwnerPanel extends Component<AccountOwnerPanelProps> {
  public render() {
    return (
      <Flex>
        <Box width={2 / 3}>
          <Module>
            <Box>
              <ModuleHeader>
                <div>Change account owner</div>
              </ModuleHeader>
              <ModuleContent>
                <Flex>
                  <OwnerForm {...this.props} />
                </Flex>
              </ModuleContent>
            </Box>
          </Module>
        </Box>
      </Flex>
    );
  }
}
